export default __webpack_public_path__ + "static/media/Sherwin Samuel.52493cb1.jpeg";